/* unplugin-vue-components disabled */import { render } from "./CommonTopTitle.vue?vue&type=template&id=67ce037e&scoped=true"
import script from "./CommonTopTitle.vue?vue&type=script&lang=js"
export * from "./CommonTopTitle.vue?vue&type=script&lang=js"

import "./CommonTopTitle.vue?vue&type=style&index=0&id=67ce037e&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ce037e"]])

export default __exports__